'use client';
import { Box, Flex, useRadioGroup } from '@chakra-ui/react';
import React from 'react';

import CustomRadioButton from '@/app/_components/custom-radio-button/CustomRadioButton';
import { BALLOONPAYMENT } from '@/constants/payment-method/payment.constants';
const BallonPaymentButtons = ({
  value,
  onChange,
}: {
  value: '%' | 'R';
  onChange: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const { getRadioProps, getRootProps } = useRadioGroup({
    defaultValue: value,
    onChange: onChange,
  });

  return (
    <Box {...getRootProps()}>
      <Flex gap={'10px'}>
        {BALLOONPAYMENT.map((value, index) => {
          return (
            <CustomRadioButton
              key={index}
              radioValue={value}
              {...getRadioProps({ value: value })}
            />
          );
        })}
      </Flex>
    </Box>
  );
};

export default BallonPaymentButtons;
